const buttonNames = [
  {
    id: "about",
    linkTo: "/about",
    name: "About me",
  },
  {
    id: "projects",
    linkTo: "/projects",
    name: "Projects",
  },
  {
    id: "skills",
    linkTo: "/skills",
    name: "Skills",
  },
  {
    id: "jobs",
    linkTo: "/jobs",
    name: "Education & Jobs",
  },
];

export default buttonNames;
